export const accent = '#ef7a12';
